// extracted by mini-css-extract-plugin
export default {"container":"AppContainer_container__-0HJF"};